/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
} from "@angular/common/http";
import { CustomHttpParameterCodec } from "../encoder";
import { Observable } from "rxjs";

import { CustomerOrderCopyResponseModel } from "../model/models";
import { CustomerOrderDataModel } from "../model/models";
import { CustomerOrderInsertModel } from "../model/models";
import { CustomerOrderPickingModel } from "../model/models";
import { CustomerOrderUpdateModel } from "../model/models";
import { DeliveredShelfLifeResponseModel } from "../model/models";
import { GeoLocationEventResponseModel } from "../model/models";
import { ReportResponseModel } from "../model/models";
import { WebFilter } from "../model/models";
import { WorkOrderDataModel } from "../model/models";

import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

export interface ApiCustomerorderAuditcustomerorderstatereportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiCustomerorderCopyPostRequestParams {
  customerOrderNumber?: string;
}

export interface ApiCustomerorderCustomerOrderNatAccountsReportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiCustomerorderCustomerorderdetailreportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiCustomerorderCustomerorderfillratereportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiCustomerorderCustomerorderreportIdGetRequestParams {
  id: number;
}

export interface ApiCustomerorderCustomerordersummaryreportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiCustomerorderCustomerordertimelinereportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiCustomerorderDeliveredshelflifeGetRequestParams {
  customerNumber?: string;
  expGroup?: string;
}

export interface ApiCustomerorderGeolocationeventsGetRequestParams {
  locationId?: number;
  periodDays?: number;
  datePicker?: string;
  customerSearch?: string;
  userNameSearch?: string;
}

export interface ApiCustomerorderGeolocationeventsexportGetRequestParams {
  locationId?: number;
  periodDays?: number;
  datePicker?: string;
  customerSearch?: string;
  userNameSearch?: string;
}

export interface ApiCustomerorderIdGetRequestParams {
  id: number;
}

export interface ApiCustomerorderInsertPostRequestParams {
  customerOrderInsertModel?: CustomerOrderInsertModel;
}

export interface ApiCustomerorderListExportGetRequestParams {
  search?: string;
  workflowStatusId?: string;
  outputType?: string;
  locationId?: number;
  periodDays?: number;
}

export interface ApiCustomerorderListGetRequestParams {
  search?: string;
  workflowStatusId?: string;
  periodDays?: number;
  locationId?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiCustomerorderManageGetRequestParams {
  pickerGroup?: string;
  pickerItem?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
  workflowStatusId?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiCustomerorderPickCustomerOrderPostRequestParams {
  customerOrderPickingModel?: CustomerOrderPickingModel;
}

export interface ApiCustomerorderPickingGetRequestParams {
  search?: string;
  salesPersonId?: string;
  periodDays?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiCustomerorderRtoExportGetRequestParams {
  search?: string;
  workflowStatusId?: string;
  outputType?: string;
  pLocationId?: number;
  periodDays?: number;
}

export interface ApiCustomerorderRtodashboardGetRequestParams {
  search?: string;
  workflowStatusId?: string;
  periodDays?: number;
  locationId?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiCustomerorderRtodashboardurlGetRequestParams {
  locationId?: number;
}

export interface ApiCustomerorderUpdatePutRequestParams {
  customerOrderUpdateModel?: CustomerOrderUpdateModel;
}

export interface ApiCustomerorderVoidIdDeleteRequestParams {
  id: number;
}

export interface ApiCustomerorderVoidmanageIdsDeleteRequestParams {
  ids: string;
}

@Injectable({
  providedIn: "root",
})
export class CustomerOrderService {
  protected basePath = "";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(
    httpParams: HttpParams,
    value: any,
    key?: string,
  ): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(
    httpParams: HttpParams,
    value?: any,
    key?: string,
  ): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) =>
            (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)),
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(
            key,
            (value as Date).toISOString().substr(0, 10),
          );
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k,
            )),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * Audit Customer Order State Report.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderAuditcustomerorderstatereportPost(
    requestParameters: ApiCustomerorderAuditcustomerorderstatereportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderAuditcustomerorderstatereportPost(
    requestParameters: ApiCustomerorderAuditcustomerorderstatereportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderAuditcustomerorderstatereportPost(
    requestParameters: ApiCustomerorderAuditcustomerorderstatereportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderAuditcustomerorderstatereportPost(
    requestParameters: ApiCustomerorderAuditcustomerorderstatereportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/auditcustomerorderstatereport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Copy a Customer Order
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderCopyPost(
    requestParameters: ApiCustomerorderCopyPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<CustomerOrderCopyResponseModel>;
  public apiCustomerorderCopyPost(
    requestParameters: ApiCustomerorderCopyPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<CustomerOrderCopyResponseModel>>;
  public apiCustomerorderCopyPost(
    requestParameters: ApiCustomerorderCopyPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<CustomerOrderCopyResponseModel>>;
  public apiCustomerorderCopyPost(
    requestParameters: ApiCustomerorderCopyPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const customerOrderNumber = requestParameters.customerOrderNumber;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (customerOrderNumber !== undefined && customerOrderNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>customerOrderNumber,
        "CustomerOrderNumber",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<CustomerOrderCopyResponseModel>(
      `${this.configuration.basePath}/api/customerorder/copy`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Customer Order Summary Report/Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderCustomerOrderNatAccountsReportPost(
    requestParameters: ApiCustomerorderCustomerOrderNatAccountsReportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderCustomerOrderNatAccountsReportPost(
    requestParameters: ApiCustomerorderCustomerOrderNatAccountsReportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderCustomerOrderNatAccountsReportPost(
    requestParameters: ApiCustomerorderCustomerOrderNatAccountsReportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderCustomerOrderNatAccountsReportPost(
    requestParameters: ApiCustomerorderCustomerOrderNatAccountsReportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/CustomerOrderNatAccountsReport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Customer Order Summary Report/Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderCustomerorderdetailreportPost(
    requestParameters: ApiCustomerorderCustomerorderdetailreportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderCustomerorderdetailreportPost(
    requestParameters: ApiCustomerorderCustomerorderdetailreportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderCustomerorderdetailreportPost(
    requestParameters: ApiCustomerorderCustomerorderdetailreportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderCustomerorderdetailreportPost(
    requestParameters: ApiCustomerorderCustomerorderdetailreportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/customerorderdetailreport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Customer Order Fill Rate Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderCustomerorderfillratereportPost(
    requestParameters: ApiCustomerorderCustomerorderfillratereportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderCustomerorderfillratereportPost(
    requestParameters: ApiCustomerorderCustomerorderfillratereportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderCustomerorderfillratereportPost(
    requestParameters: ApiCustomerorderCustomerorderfillratereportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderCustomerorderfillratereportPost(
    requestParameters: ApiCustomerorderCustomerorderfillratereportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/customerorderfillratereport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderCustomerorderreportIdGet(
    requestParameters: ApiCustomerorderCustomerorderreportIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiCustomerorderCustomerorderreportIdGet(
    requestParameters: ApiCustomerorderCustomerorderreportIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiCustomerorderCustomerorderreportIdGet(
    requestParameters: ApiCustomerorderCustomerorderreportIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiCustomerorderCustomerorderreportIdGet(
    requestParameters: ApiCustomerorderCustomerorderreportIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiCustomerorderCustomerorderreportIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${
        this.configuration.basePath
      }/api/customerorder/customerorderreport/${encodeURIComponent(
        String(id),
      )}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Customer Order Summary Report/Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderCustomerordersummaryreportPost(
    requestParameters: ApiCustomerorderCustomerordersummaryreportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderCustomerordersummaryreportPost(
    requestParameters: ApiCustomerorderCustomerordersummaryreportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderCustomerordersummaryreportPost(
    requestParameters: ApiCustomerorderCustomerordersummaryreportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderCustomerordersummaryreportPost(
    requestParameters: ApiCustomerorderCustomerordersummaryreportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/customerordersummaryreport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Customer Order Timeline Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderCustomerordertimelinereportPost(
    requestParameters: ApiCustomerorderCustomerordertimelinereportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderCustomerordertimelinereportPost(
    requestParameters: ApiCustomerorderCustomerordertimelinereportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderCustomerordertimelinereportPost(
    requestParameters: ApiCustomerorderCustomerordertimelinereportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderCustomerordertimelinereportPost(
    requestParameters: ApiCustomerorderCustomerordertimelinereportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/customerordertimelinereport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderDeliveredshelflifeGet(
    requestParameters: ApiCustomerorderDeliveredshelflifeGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<DeliveredShelfLifeResponseModel>;
  public apiCustomerorderDeliveredshelflifeGet(
    requestParameters: ApiCustomerorderDeliveredshelflifeGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<DeliveredShelfLifeResponseModel>>;
  public apiCustomerorderDeliveredshelflifeGet(
    requestParameters: ApiCustomerorderDeliveredshelflifeGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<DeliveredShelfLifeResponseModel>>;
  public apiCustomerorderDeliveredshelflifeGet(
    requestParameters: ApiCustomerorderDeliveredshelflifeGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const customerNumber = requestParameters.customerNumber;
    const expGroup = requestParameters.expGroup;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (customerNumber !== undefined && customerNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>customerNumber,
        "customerNumber",
      );
    }
    if (expGroup !== undefined && expGroup !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>expGroup,
        "expGroup",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<DeliveredShelfLifeResponseModel>(
      `${this.configuration.basePath}/api/customerorder/deliveredshelflife`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderGeolocationeventsGet(
    requestParameters: ApiCustomerorderGeolocationeventsGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<GeoLocationEventResponseModel>>;
  public apiCustomerorderGeolocationeventsGet(
    requestParameters: ApiCustomerorderGeolocationeventsGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<GeoLocationEventResponseModel>>>;
  public apiCustomerorderGeolocationeventsGet(
    requestParameters: ApiCustomerorderGeolocationeventsGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<GeoLocationEventResponseModel>>>;
  public apiCustomerorderGeolocationeventsGet(
    requestParameters: ApiCustomerorderGeolocationeventsGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const locationId = requestParameters.locationId;
    const periodDays = requestParameters.periodDays;
    const datePicker = requestParameters.datePicker;
    const customerSearch = requestParameters.customerSearch;
    const userNameSearch = requestParameters.userNameSearch;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }
    if (datePicker !== undefined && datePicker !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>datePicker,
        "datePicker",
      );
    }
    if (customerSearch !== undefined && customerSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>customerSearch,
        "customerSearch",
      );
    }
    if (userNameSearch !== undefined && userNameSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>userNameSearch,
        "userNameSearch",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<GeoLocationEventResponseModel>>(
      `${this.configuration.basePath}/api/customerorder/geolocationevents`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderGeolocationeventsexportGet(
    requestParameters: ApiCustomerorderGeolocationeventsexportGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderGeolocationeventsexportGet(
    requestParameters: ApiCustomerorderGeolocationeventsexportGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderGeolocationeventsexportGet(
    requestParameters: ApiCustomerorderGeolocationeventsexportGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderGeolocationeventsexportGet(
    requestParameters: ApiCustomerorderGeolocationeventsexportGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const locationId = requestParameters.locationId;
    const periodDays = requestParameters.periodDays;
    const datePicker = requestParameters.datePicker;
    const customerSearch = requestParameters.customerSearch;
    const userNameSearch = requestParameters.userNameSearch;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }
    if (datePicker !== undefined && datePicker !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>datePicker,
        "datePicker",
      );
    }
    if (customerSearch !== undefined && customerSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>customerSearch,
        "customerSearch",
      );
    }
    if (userNameSearch !== undefined && userNameSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>userNameSearch,
        "userNameSearch",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/geolocationeventsexport`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Customer Order By Id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderIdGet(
    requestParameters: ApiCustomerorderIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<CustomerOrderDataModel>;
  public apiCustomerorderIdGet(
    requestParameters: ApiCustomerorderIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<CustomerOrderDataModel>>;
  public apiCustomerorderIdGet(
    requestParameters: ApiCustomerorderIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<CustomerOrderDataModel>>;
  public apiCustomerorderIdGet(
    requestParameters: ApiCustomerorderIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiCustomerorderIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<CustomerOrderDataModel>(
      `${this.configuration.basePath}/api/customerorder/${encodeURIComponent(
        String(id),
      )}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Insert Customer Order
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderInsertPost(
    requestParameters: ApiCustomerorderInsertPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<number>;
  public apiCustomerorderInsertPost(
    requestParameters: ApiCustomerorderInsertPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<number>>;
  public apiCustomerorderInsertPost(
    requestParameters: ApiCustomerorderInsertPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<number>>;
  public apiCustomerorderInsertPost(
    requestParameters: ApiCustomerorderInsertPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const customerOrderInsertModel = requestParameters.customerOrderInsertModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<number>(
      `${this.configuration.basePath}/api/customerorder/insert`,
      customerOrderInsertModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Customer Order Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderListExportGet(
    requestParameters: ApiCustomerorderListExportGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderListExportGet(
    requestParameters: ApiCustomerorderListExportGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderListExportGet(
    requestParameters: ApiCustomerorderListExportGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderListExportGet(
    requestParameters: ApiCustomerorderListExportGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const search = requestParameters.search;
    const workflowStatusId = requestParameters.workflowStatusId;
    const outputType = requestParameters.outputType;
    const locationId = requestParameters.locationId;
    const periodDays = requestParameters.periodDays;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (workflowStatusId !== undefined && workflowStatusId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowStatusId,
        "workflowStatusId",
      );
    }
    if (outputType !== undefined && outputType !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>outputType,
        "outputType",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/listExport`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get All Customer Order Actives
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderListGet(
    requestParameters: ApiCustomerorderListGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiCustomerorderListGet(
    requestParameters: ApiCustomerorderListGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiCustomerorderListGet(
    requestParameters: ApiCustomerorderListGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiCustomerorderListGet(
    requestParameters: ApiCustomerorderListGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const search = requestParameters.search;
    const workflowStatusId = requestParameters.workflowStatusId;
    const periodDays = requestParameters.periodDays;
    const locationId = requestParameters.locationId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (workflowStatusId !== undefined && workflowStatusId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowStatusId,
        "workflowStatusId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${this.configuration.basePath}/api/customerorder/list`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Customer Order to Manage
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderManageGet(
    requestParameters: ApiCustomerorderManageGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiCustomerorderManageGet(
    requestParameters: ApiCustomerorderManageGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiCustomerorderManageGet(
    requestParameters: ApiCustomerorderManageGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiCustomerorderManageGet(
    requestParameters: ApiCustomerorderManageGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const pickerGroup = requestParameters.pickerGroup;
    const pickerItem = requestParameters.pickerItem;
    const fromDate = requestParameters.fromDate;
    const toDate = requestParameters.toDate;
    const search = requestParameters.search;
    const workflowStatusId = requestParameters.workflowStatusId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (pickerGroup !== undefined && pickerGroup !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerGroup,
        "PickerGroup",
      );
    }
    if (pickerItem !== undefined && pickerItem !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerItem,
        "PickerItem",
      );
    }
    if (fromDate !== undefined && fromDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>fromDate,
        "FromDate",
      );
    }
    if (toDate !== undefined && toDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>toDate,
        "ToDate",
      );
    }
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (workflowStatusId !== undefined && workflowStatusId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowStatusId,
        "workflowStatusId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${this.configuration.basePath}/api/customerorder/manage`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Pick Customer Order
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderPickCustomerOrderPost(
    requestParameters: ApiCustomerorderPickCustomerOrderPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<WorkOrderDataModel>;
  public apiCustomerorderPickCustomerOrderPost(
    requestParameters: ApiCustomerorderPickCustomerOrderPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<WorkOrderDataModel>>;
  public apiCustomerorderPickCustomerOrderPost(
    requestParameters: ApiCustomerorderPickCustomerOrderPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<WorkOrderDataModel>>;
  public apiCustomerorderPickCustomerOrderPost(
    requestParameters: ApiCustomerorderPickCustomerOrderPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const customerOrderPickingModel =
      requestParameters.customerOrderPickingModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<WorkOrderDataModel>(
      `${this.configuration.basePath}/api/customerorder/pickCustomerOrder`,
      customerOrderPickingModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get All Customer Order ready for Picking
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderPickingGet(
    requestParameters: ApiCustomerorderPickingGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiCustomerorderPickingGet(
    requestParameters: ApiCustomerorderPickingGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiCustomerorderPickingGet(
    requestParameters: ApiCustomerorderPickingGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiCustomerorderPickingGet(
    requestParameters: ApiCustomerorderPickingGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const search = requestParameters.search;
    const salesPersonId = requestParameters.salesPersonId;
    const periodDays = requestParameters.periodDays;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (salesPersonId !== undefined && salesPersonId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>salesPersonId,
        "salesPersonId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${this.configuration.basePath}/api/customerorder/picking`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Real Time Orders Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderRtoExportGet(
    requestParameters: ApiCustomerorderRtoExportGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiCustomerorderRtoExportGet(
    requestParameters: ApiCustomerorderRtoExportGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiCustomerorderRtoExportGet(
    requestParameters: ApiCustomerorderRtoExportGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiCustomerorderRtoExportGet(
    requestParameters: ApiCustomerorderRtoExportGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const search = requestParameters.search;
    const workflowStatusId = requestParameters.workflowStatusId;
    const outputType = requestParameters.outputType;
    const pLocationId = requestParameters.pLocationId;
    const periodDays = requestParameters.periodDays;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (workflowStatusId !== undefined && workflowStatusId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowStatusId,
        "workflowStatusId",
      );
    }
    if (outputType !== undefined && outputType !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>outputType,
        "outputType",
      );
    }
    if (pLocationId !== undefined && pLocationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pLocationId,
        "p_locationId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<ReportResponseModel>(
      `${this.configuration.basePath}/api/customerorder/rtoExport`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Real Time Orders Dashboard
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderRtodashboardGet(
    requestParameters: ApiCustomerorderRtodashboardGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiCustomerorderRtodashboardGet(
    requestParameters: ApiCustomerorderRtodashboardGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiCustomerorderRtodashboardGet(
    requestParameters: ApiCustomerorderRtodashboardGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiCustomerorderRtodashboardGet(
    requestParameters: ApiCustomerorderRtodashboardGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const search = requestParameters.search;
    const workflowStatusId = requestParameters.workflowStatusId;
    const periodDays = requestParameters.periodDays;
    const locationId = requestParameters.locationId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (workflowStatusId !== undefined && workflowStatusId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowStatusId,
        "workflowStatusId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${this.configuration.basePath}/api/customerorder/rtodashboard`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Real Time Orders Dashboard
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderRtodashboardurlGet(
    requestParameters: ApiCustomerorderRtodashboardurlGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiCustomerorderRtodashboardurlGet(
    requestParameters: ApiCustomerorderRtodashboardurlGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiCustomerorderRtodashboardurlGet(
    requestParameters: ApiCustomerorderRtodashboardurlGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiCustomerorderRtodashboardurlGet(
    requestParameters: ApiCustomerorderRtodashboardurlGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const locationId = requestParameters.locationId;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "text";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${this.configuration.basePath}/api/customerorder/rtodashboardurl`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Update CustomerOrder
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderUpdatePut(
    requestParameters: ApiCustomerorderUpdatePutRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<boolean>;
  public apiCustomerorderUpdatePut(
    requestParameters: ApiCustomerorderUpdatePutRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<boolean>>;
  public apiCustomerorderUpdatePut(
    requestParameters: ApiCustomerorderUpdatePutRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<boolean>>;
  public apiCustomerorderUpdatePut(
    requestParameters: ApiCustomerorderUpdatePutRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const customerOrderUpdateModel = requestParameters.customerOrderUpdateModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.put<boolean>(
      `${this.configuration.basePath}/api/customerorder/update`,
      customerOrderUpdateModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Delete Customer Order (Void)
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderVoidIdDelete(
    requestParameters: ApiCustomerorderVoidIdDeleteRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<boolean>;
  public apiCustomerorderVoidIdDelete(
    requestParameters: ApiCustomerorderVoidIdDeleteRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<boolean>>;
  public apiCustomerorderVoidIdDelete(
    requestParameters: ApiCustomerorderVoidIdDeleteRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<boolean>>;
  public apiCustomerorderVoidIdDelete(
    requestParameters: ApiCustomerorderVoidIdDeleteRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiCustomerorderVoidIdDelete.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.delete<boolean>(
      `${
        this.configuration.basePath
      }/api/customerorder/void/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Void Customer Order List
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiCustomerorderVoidmanageIdsDelete(
    requestParameters: ApiCustomerorderVoidmanageIdsDeleteRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<boolean>;
  public apiCustomerorderVoidmanageIdsDelete(
    requestParameters: ApiCustomerorderVoidmanageIdsDeleteRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<boolean>>;
  public apiCustomerorderVoidmanageIdsDelete(
    requestParameters: ApiCustomerorderVoidmanageIdsDeleteRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<boolean>>;
  public apiCustomerorderVoidmanageIdsDelete(
    requestParameters: ApiCustomerorderVoidmanageIdsDeleteRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const ids = requestParameters.ids;
    if (ids === null || ids === undefined) {
      throw new Error(
        "Required parameter ids was null or undefined when calling apiCustomerorderVoidmanageIdsDelete.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.delete<boolean>(
      `${
        this.configuration.basePath
      }/api/customerorder/voidmanage/${encodeURIComponent(String(ids))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
